import config from "../config";

//公共图片路径处理文件
export function forMat() {
    return config.fontUrl;
}

// 判断浏览器的头是否为移动端
export function perfix() {
    if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
       console.log("执行了123");
       return true;
    } else {
      console.log("执行了456");
      return false;
    }
  }
  // 我要参展
export function viewcz() {
  return config.viewcz;
}
// 我要参观
export function viewcg() {
  return config.viewcg;
}
// 展位图
export function zwt() {
  return config.zwt;
}
// 展会日程
export function zhrc() {
  return config.zhrc;
}
// 展会官网
export function hzZhanhui() {
  return config.hzzhanhui;
}